import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

export function listIsupAccessControls(params) {
  return request({
    url: '/isupDevice.listPropertyDevices',
    method: 'get',
    params: {
      ...params,
      communityId: getCommunityId()
    }
  }).then(response => {
    const result = response.data
    if (result.code !== 0) {
      throw new Error(result.msg || '获取门禁设备失败')
    }
    return result
  })
}

export function nameIsupAccessControl(data) {
  return request({
    url: '/isupDevice.nameDevice',
    method: 'post',
    data: {
      registryId: data.registryId,
      machineName: data.machineName,
      communityId: getCommunityId()
    }
  }).then(response => {
    const result = response.data
    if (result.code !== 0) {
      throw new Error(result.msg || '保存门禁名称失败')
    }
    return result
  })
}
